import script from "./ExportPreference.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportPreference.vue?vue&type=script&setup=true&lang=ts"

import "./ExportPreference.vue?vue&type=style&index=0&id=f8e8535c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8e8535c"]])

export default __exports__